const STATIC_ASSETS_URL = 'https://marketplace-web-assets.vinted.com'

function useAssetHost() {
  return process.env.NODE_ENV === 'production' ? STATIC_ASSETS_URL : '/'
}

export default useAssetHost
